<template>
  <div>
    <base-page-heading :title="reportTitle" />
    <div class="content">
      <revenue-list-filter
        :table-name="tableName"
        :columns="columns"
        :initial-filters="filters"
        @filters-applied="applyFilters"
      />
      <b-row
        class="font-size-sm align-items-center"
      >
        <b-col cols="auto">
          <b-link @click.prevent="quickDatesCurrentFy">
            Current Fiscal Year
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click.prevent="quickDatesLastFy">
            Last Fiscal Year to Date
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click.prevent="quickDatesCalendarYtd">
            Current Year to Date
          </b-link>
        </b-col>
        <b-col
          cols="auto"
          class="ml-auto text-right"
        >
          <b-link @click="onGroupByChanged('year')">
            By Year
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click="onGroupByChanged('month')">
            By Month
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click="onGroupByChanged('state')">
            By State
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click="onGroupByChanged('manager')">
            By Manager
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click="onGroupByChanged('client')">
            By Client
          </b-link>
          <span class="pl-1 pr-1">|</span>
          <b-link @click="onGroupByChanged('service_category')">
            By Service Category
          </b-link>
        </b-col>
      </b-row>
      <revenue-table
        class="mt-2"
        :filters="filters"
        :columns="columns"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
        :key="tableKey"
      />
    </div>
  </div>
</template>

<script>
import listMixin from '@/mixins/listMixin';
import RevenueListFilter from '@/components/admin/reports/invoices/RevenueListFilter.vue';
import RevenueTable from '@/components/admin/reports/invoices/RevenueTable.vue';
import { WORK_ORDER_REVENUE_REPORT_TABLE_NAME } from '@/constants/reports';
import {
  revenueReportDefaultFiscalYearDates,
  revenueReportLastFiscalYearDateRange,
  revenueReportCalendarYearToDateRange,
  normalizeRevenueReportDateQueryParam,
} from '@/utils/revenueReportDefaultFiscalYearDates';

export default {
  name: 'WorkOrdersRevenueReport',
  components: {
    RevenueTable,
    RevenueListFilter,
  },
  mixins: [listMixin],
  props: {
    client_id: String,
    service_id: String,
    service_category: String,
    manager_id: String,
    state: String,
    start_date: String,
    end_date: String,
    group_by: String,
  },
  data() {
    const defaults = revenueReportLastFiscalYearDateRange();
    const fromQuery = Boolean(this.start_date || this.end_date);

    return {
      tableName: WORK_ORDER_REVENUE_REPORT_TABLE_NAME,
      filters: {
        client_id: this.client_id,
        service_id: this.service_id,
        service_category: this.service_category,
        manager_id: this.manager_id,
        state: this.state,
        start_date: fromQuery ? (normalizeRevenueReportDateQueryParam(this.start_date) || this.start_date) : defaults.start_date,
        end_date: fromQuery ? (normalizeRevenueReportDateQueryParam(this.end_date) || this.end_date) : defaults.end_date,
        group_by: this.group_by,
      },
      tableKey: Date.now(),
    };
  },
  computed: {
    reportTitle() {
      if (this.filters.group_by) {
        const groupByLabel = this.filters.group_by.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        return `Revenue Report by ${groupByLabel}`;
      }
      return 'Revenue Report';
    },
  },
  methods: {
    setFilterDates(start_date, end_date) {
      this.filters = { ...this.filters, start_date, end_date };
      this.appendObjectToQueryParams(this.filters);
      this.tableKey = Date.now();
    },
    quickDatesCurrentFy() {
      const { start_date, end_date } = revenueReportDefaultFiscalYearDates();
      this.setFilterDates(start_date, end_date);
    },
    quickDatesLastFy() {
      const { start_date, end_date } = revenueReportLastFiscalYearDateRange();
      this.setFilterDates(start_date, end_date);
    },
    quickDatesCalendarYtd() {
      const { start_date, end_date } = revenueReportCalendarYearToDateRange();
      this.setFilterDates(start_date, end_date);
    },
    onGroupByChanged(groupBy) {
      this.filters = { ...this.filters, group_by: groupBy };
      this.appendObjectToQueryParams(this.filters);
      this.tableKey = Date.now();
    },
  },
};
</script>
